<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        {{ headline }}
      </h5>
    </div>

    <div class="panel-body">
      <form @submit.prevent="$emit('submit', data)">
        <TextFormGroup
            v-model="data.text"
            name="text"
            label="Text"
            help-text="The text of the primary menu link child."
            :error="(errors.text || [])[0]"
        />

        <TextFormGroup
            v-model="data.path"
            name="path"
            label="Path"
            help-text="The path of the primary menu link child."
            :error="(errors.path || [])[0]"
        />

        <SubmitFormGroup button-class="btn-black"/>
      </form>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {SubmitFormGroup, TextFormGroup},

  props: {
    headline: {
      required: true,
      type: String
    },

    initial: {
      required: false,
      type: Object,
      default: () => ({})
    },

    errors: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      data: {...this.initial},

      shared: store
    }
  }
}
</script>